import { Configure, Hits, useConnector } from 'react-instantsearch-hooks-web';
import connectStats from 'instantsearch.js/es/connectors/stats/connectStats';
import { useSitecoreContext } from '@sitecore-jss/sitecore-jss-nextjs';
import type {
  StatsConnectorParams,
  StatsWidgetDescription,
} from 'instantsearch.js/es/connectors/stats/connectStats';
import { CustomPagination } from '../../CustomPagination';
import classnames from 'tailwindcss-classnames';
import { HitProps } from '../../Hits/_types';
import NrcSearchHit from 'components/helpers/AlgoliaSearch/NetworkResourceCenter/NRCSearchHit';

export type UseStatsProps = StatsConnectorParams;

function useStats(props?: UseStatsProps) {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  return useConnector<StatsConnectorParams, StatsWidgetDescription>(connectStats as any, props);
}

const ProductListSearchHit = ({ hit }: HitProps) => {
  return <NrcSearchHit hit={hit} component="productList" />;
};

const SearchResultsWithSearch = (props: UseStatsProps) => {
  const { nbHits } = useStats(props);
  const configureFilters = `type:productlist`;
  const showPagination = nbHits > 20;
  return (
    <div className={classnames('products')}>
      <Configure analytics={false} filters={configureFilters} hitsPerPage={20} />
      <div>
        <Hits hitComponent={ProductListSearchHit} />
      </div>
      <div className={classnames({ hidden: !showPagination })}>
        <CustomPagination padding={1} />
      </div>
    </div>
  );
};

const SearchResults = (props: UseStatsProps) => {
  const { sitecoreContext } = useSitecoreContext();
  const pageEditing = sitecoreContext.pageEditing === true;
  if (pageEditing) {
    return <div>Search Results will be shown here</div>;
  }
  return <SearchResultsWithSearch {...props} />;
};

export default SearchResults;
